module.exports = __webpack_public_path__ + "img/d5.3cc53e2e.jpg";